import React from 'react';
import renderHTML from 'react-render-html';
import { TextArea } from 'telstra-ui/components/text-area/TextArea';
import { Button } from 'telstra-ui/components/button/Button';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';

const SubmitSection = (props) => {
  const {
    authorableContent: {
      description,
      contactFieldDescription,
      confirmButton,
    },
    handleOnchangeTextArea,
    preferredTimeContacted,
    onSubmitSiteConfirmButton,
    submitLoader,
  } = props;

  return (
    <React.Fragment>
      <div className="row submit-section">
        <div className="col-12 pl-sm-0 pr-sm-0 paddingS">
          {renderHTML(stripStartingAndEndingPTags(description))}
        </div>
      </div>
      <div className="row">
        <div className="col-12 pl-sm-0 pr-sm-0 paddingXXS">
          <TextArea
            rows={7}
            value={preferredTimeContacted}
            label={contactFieldDescription}
            maxLength={200}
            onChange={handleOnchangeTextArea}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 button-section pl-sm-0 pr-sm-0 paddingS text-center-mobile">
          <Button
            variant="super"
            onClick={onSubmitSiteConfirmButton}
            state={submitLoader ? 'loading' : 'app'}
          >
            {confirmButton}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SubmitSection;
